import Vue from 'vue'
import App from './App.vue'
import VueStatic from "vue-static"
import VueMeta from 'vue-meta'
import * as api from "./api/firebase";


import { library } from '@fortawesome/fontawesome-svg-core'
import { faItunesNote } from '@fortawesome/free-brands-svg-icons'
import { faTint, faExpand, faInfo, faMobileAlt, faTshirt, faAngleUp, faMedal, faAppleAlt, faShoppingBag, faParking, faShower, faCaretDown, faCaretUp, faUser, faPlusCircle, faHome, faBus, faMapMarkerAlt, faMapMarker, faUndoAlt, faRedoAlt, faRoute } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import "./global.css";
import router from './router'
import store from './vuex/store'
import { Console } from 'console';

//Icon Setup. TODO: move
library.add(faItunesNote, faTint, faExpand, faInfo, faMobileAlt, faTshirt, faAngleUp, faMedal, faAppleAlt, faShoppingBag, faParking, faShower, faCaretDown, faCaretUp, faUser, faPlusCircle, faHome, faBus, faMapMarkerAlt, faMapMarker, faUndoAlt, faRedoAlt, faRoute)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueStatic, {namespaced:true});
Vue.use(VueMeta);
Vue.config.productionTip = false;

async function start() {

	const authChanged = (user) => {
		store.dispatch("authStateChanged", user);
	}

	const result = await api.initFirebase(authChanged);

	if(!result.success)
		store.commit("alert/addMessage", result.error);

	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app')
}

start();